import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

import { customColors } from '../../theme/customColors';

const { text } = customColors;

const baseStyle = defineStyle({
  color: text.heading,
  fontFamily: 'heading',
});

const variants = {
  heading: defineStyle({
    fontWeight: 'medium',
  }),
  title: defineStyle({
    // Matches `size="md"` (14/20) so `variant="title"` and `size="md"` stay the
    // same size. Keep in sync with `.text-title` in
    // `packages/studio/src/styles/tailwind.import.css`.
    fontSize: 'md',
    fontWeight: 'medium',
    lineHeight: 'md',
  }),
};

const sizes = {
  md: defineStyle({
    fontSize: 'md',
    lineHeight: 'md',
    letterSpacing: 'headingMd',
  }),
  lg: defineStyle({
    fontSize: 'lg',
    lineHeight: 'lg',
    letterSpacing: 'headingLg',
  }),
  xl: defineStyle({
    fontSize: 'xl',
    lineHeight: 'xl',
    letterSpacing: 'headingXl',
  }),
  '2xl': defineStyle({
    fontSize: '2xl',
    lineHeight: '2xl',
    letterSpacing: 'heading2xl',
  }),
  '3xl': defineStyle({
    fontSize: '3xl',
    lineHeight: '3xl',
    letterSpacing: 'heading3xl',
  }),
};

export const HeadingStyles = defineStyleConfig({
  baseStyle,
  variants,
  sizes,
  defaultProps: { size: 'lg', variant: 'heading' },
});
